import { init, miniApp, retrieveRawInitData, themeParams, viewport } from '@tma.js/sdk-vue';

export async function initializeTelegram(): Promise<void> {
  try {
    init();
    if (themeParams.mount.isAvailable()) themeParams.mount();
    if (miniApp.mount.isAvailable()) miniApp.mount();
    if (viewport.mount.isAvailable()) await viewport.mount();
  } catch {
    // Browser preview and older Telegram clients still work through the official bridge.
  }
  const webApp = window.Telegram?.WebApp;
  webApp?.ready();
  webApp?.expand();
  webApp?.enableClosingConfirmation();
  document.documentElement.dataset.telegramTheme = webApp?.colorScheme ?? 'light';
}

export function telegramInitData(): string {
  const bridgeInitData = window.Telegram?.WebApp?.initData;
  if (bridgeInitData) return bridgeInitData;
  try {
    const sdkInitData = retrieveRawInitData();
    if (sdkInitData) return sdkInitData;
  } catch {
    // Outside Telegram there are no launch parameters to retrieve.
  }
  return import.meta.env.VITE_DEV_INIT_DATA || '';
}

export function telegramUserPhotoUrl(): string | undefined {
  const value = window.Telegram?.WebApp?.initDataUnsafe?.user?.photo_url?.trim();
  return value || undefined;
}

export function haptic(type: 'light' | 'medium' | 'heavy' = 'light'): void {
  window.Telegram?.WebApp?.HapticFeedback?.impactOccurred(type);
}

export function openTelegram(url: string): void {
  if (window.Telegram?.WebApp) window.Telegram.WebApp.openTelegramLink(url);
  else window.open(url, '_blank', 'noopener,noreferrer');
}
